//Components
import ErrorPhone from '../../components/error/error_phone_version'
import PhoneHeader from '../../components/phoneresponsive/phone_header'
import Competences from '../../components/cv/statscard_competences'
import Language from '../../components/cv/statscard_langues'
import PhoneFooter from '../../components/phoneresponsive/phone_footer'

//Language
import { useLanguage } from '../../context/language_context'


function CvStats() {

    const { language } = useLanguage()

    return (

        <div className="phone_projects">

            <ErrorPhone />

            <PhoneHeader />

            <p className='phone_projects_title'>
                {language === 'fr'
                    ? 'Compétences'
                    : 'Skills'}
            </p>

            <div className='cv_card phone_stats_container'>

                <div className='cv_card_main phone_stats'>

                    <Language />

                    <Competences />

                </div>

            </div>

            <PhoneFooter />

        </div>

    )
}


export default CvStats